import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import * as AuthActions from '../auth/auth.actions';
import { AuthStatus } from '@lmc-app/shared/enum/auth-status.enum';
import { User } from '@lmc-app/shared/interface/user.interface';

export interface UserState {
	user: User | null;
	authStatus: AuthStatus;
	error: any;
}

export const initialState: UserState = {
	user: null,
	authStatus: AuthStatus.UNKNOWN,
	error: null,
};

export const userReducer = createReducer(
	initialState,

	// Start loading
	on(UserActions.loadUser, (state) => ({
		...state,
		authStatus: AuthStatus.LOADING,
		error: null,
	})),

	// Success
	on(UserActions.loadUserSuccess, (state, { user }) => ({
		...state,
		user,
		authStatus: AuthStatus.AUTHENTICATED,
		error: null,
	})),

	// Failure
	on(UserActions.loadUserFailure, (state, { error }) => ({
		...state,
		user: null,
		authStatus: AuthStatus.UNAUTHENTICATED,
		error,
	})),

	// Session expired
	on(UserActions.sessionExpired, (state) => ({
		...state,
		user: null,
		authStatus: AuthStatus.SESSION_EXPIRED,
		error: null,
	})),

	// Clear user (logout)
	on(UserActions.clearUser, (state) => ({
		...state,
		user: null,
		authStatus: AuthStatus.UNAUTHENTICATED,
		error: null,
	})),

	// Authentication error
	on(UserActions.authenticationError, (state, { error }) => ({
		...state,
		user: null,
		authStatus: AuthStatus.ERROR,
		error,
	})),

	// Update user
	on(UserActions.updateUser, (state, { user: userUpdate }) => ({
		...state,
		user: state.user ? { ...state.user, ...userUpdate } : null,
	})),

	// Listen to Auth login success - set user state
	on(AuthActions.loginSuccess, (state, { user }) => ({
		...state,
		user,
		authStatus: AuthStatus.AUTHENTICATED,
		error: null,
	})),

	// Listen to Auth logout - immediately set UNAUTHENTICATED and clear user
	on(AuthActions.logout, () => ({
		...initialState,
		authStatus: AuthStatus.UNAUTHENTICATED,
	})),

	// Listen to Auth initialize session - set loading state
	on(AuthActions.initializeSession, (state) => ({
		...state,
		authStatus: AuthStatus.LOADING,
		error: null,
	})),

	// Listen to Auth initialize session success - set user state
	on(AuthActions.initializeSessionSuccess, (state, { user }) => ({
		...state,
		user,
		authStatus: AuthStatus.AUTHENTICATED,
		error: null,
	})),

	// Listen to Auth initialize session failure - reset user state
	on(AuthActions.initializeSessionFailure, (state) => ({
		...state,
		user: null,
		authStatus: AuthStatus.UNAUTHENTICATED,
		error: null,
	}))
);
